module.exports = __webpack_public_path__ + "img/informationLaw_sign.692bf106.png";